/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable prefer-template */
import { format } from "date-fns";
import { axiosInstanceAutomatedBilling } from "../axios";
import { ClientCreate, ClientCreations, RequestResponse } from "../types";

export const getClient = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      `/api/v1/client/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    console.error("Unable to fetch client: ", err);
    let errorMessage =
      "Request failed with status code " + err.response?.status;
    if (err.response?.data && err.response.data.data) {
      errorMessage = err.response.data.data;
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};

export const getClients: (
  pageNumber: number,
  pageSize: number
) => Promise<
  RequestResponse<{ records: ClientCreations[]; total: number }>
> = async (pageNumber, pageSize) => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      "/api/v1/client/all",
      {
        params: { pageNumber, pageSize }
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.data,
        total: response.data.data.totalCount
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch client: ", err);
    let errorMessage =
      "Request failed with status code " + err.response?.status;
    if (err.response?.data && err.response.data.data) {
      errorMessage = err.response.data.data;
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};

export const updateClient = async (
  id: number,
  payload: ClientCreate
): Promise<RequestResponse> => {
  try {
    const formattedPayload = {
      id,
      ...payload,
      lastBillDate: format(
        new Date(payload.lastBillDate),
        "yyyy-MM-dd HH:mm:ss"
      )
    };
    await axiosInstanceAutomatedBilling.put(
      `/api/v1/client/${id}`,
      formattedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update client: ", err);
    let errorMessage =
      "Request failed with status code " + err.response?.status;
    if (err.response?.data && err.response.data.data) {
      errorMessage = err.response.data.data;
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};

export const createClient = async (
  payload: ClientCreate
): Promise<RequestResponse> => {
  const formattedPayload = {
    ...payload,
    lastBillDate: format(new Date(payload.lastBillDate), "yyyy-MM-dd HH:mm:ss")
  };
  try {
    await axiosInstanceAutomatedBilling.post(
      `/api/v1/client`,
      formattedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create client: ", err);
    let errorMessage =
      "Request failed with status code " + err.response?.status;
    if (err.response?.data && err.response.data.data) {
      errorMessage = err.response.data.data;
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};
